{
  "titles": {
    "appointmentDetailsHaveChanged": "Los detalles de la cita han cambiado",
    "appointmentScheduled": "Cita programada",
    "appointmentConfirmed": "Cita confirmada",
    "appointmentRequested": "Cita solicitada",
    "missedAppointment": "Cita perdida",
    "recurringAppointmentSeriesCreated": "Serie de citas recurrentes creada",
    "truckArrivedAtFacility": "Camión llegó a la instalación",
    "appointmentIsInProgressAtFacility": "Cita en curso en la instalación",
    "appointmentRescheduled": "Cita reprogramada",
    "appointmentCompleted": "Cita completada",
    "appointmentCancelled": "Cita cancelada",
    "appointmentTagged": "Cita etiquetada",
    "assetReadyForPickup": "Activo listo para recoger"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "Los detalles de la cita han cambiado",
    "appointmentScheduled": "Cita programada en {orgName} - {warehouseName}",
    "appointmentConfirmed": "Cita confirmada en {orgName} - {warehouseName}",
    "appointmentRequested": "Cita solicitada en {orgName} - {warehouseName}",
    "missedAppointment": "Cita perdida en {orgName} - {warehouseName}",
    "recurringAppointmentSeriesCreated": "Se ha creado una serie de citas recurrentes",
    "truckArrivedAtFacility": "Camión llegó a {orgName} - {warehouseName}",
    "appointmentIsInProgressAtFacility": "Cita en curso en {orgName} - {warehouseName}",
    "appointmentRescheduled": "Cita reprogramada en {orgName} - {warehouseName}",
    "appointmentCompleted": "Cita completada en {orgName} - {warehouseName}",
    "appointmentCancelled": "Cita cancelada con {orgName} - {warehouseName}",
    "appointmentTagged": "Cita etiquetada como {tagName} - {warehouseName}",
    "assetReadyForPickup": "Listo para recoger - Contenedor {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "Por favor, revise la ubicación, fecha, hora y todos los detalles a continuación.",
    "appointmentScheduled": "Por favor, revise la ubicación, fecha, hora y todos los detalles a continuación.",
    "appointmentConfirmed": "Por favor, revise la ubicación, fecha, hora y todos los detalles a continuación.",
    "appointmentRequested": "Por favor, espere la confirmación del almacén.",
    "missedAppointment": "El transportista no se presentó a la cita.",
    "recurringAppointmentSeriesCreated": "Por favor, revise los detalles de la cita recurrente a continuación.",
    "truckArrivedAtFacility": "Revise el estado y los detalles de la cita a continuación.",
    "appointmentIsInProgressAtFacility": "Revise el estado y los detalles de la cita a continuación.",
    "appointmentRescheduled": "Revise el estado y los detalles de la cita a continuación.",
    "appointmentCompleted": "Revise el estado y los detalles de la cita a continuación.",
    "appointmentCancelled": "Por favor, revise todos los detalles y el motivo de la cancelación.",
    "appointmentTagged": "Por favor, revise el nombre de la etiqueta y la información a continuación.",
    "assetReadyForPickup": "Un activo en su instalación está listo para ser recogido."
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "Ver cita",
    "appointmentScheduled": "Ver cita",
    "appointmentConfirmed": "Ver cita",
    "appointmentRequested": "Ver cita",
    "missedAppointment": "Ver cita",
    "recurringAppointmentSeriesCreated": "Ver cita original",
    "truckArrivedAtFacility": "Ver cita",
    "appointmentIsInProgressAtFacility": "Ver cita",
    "appointmentRescheduled": "Ver cita",
    "appointmentCompleted": "Ver cita",
    "appointmentCancelled": "Ver cita",
    "appointmentTagged": "Ver cita",
    "assetReadyForPickup": "Ver cita"
  },
  "descriptions": {
    "appointmentTagged": "Utilice la configuración de etiquetas de cita para habilitarlas individualmente"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "Programar recogida",
      "idLabel": "Número de confirmación",
      "ownedByLabel": "Propietario:",
      "pickupScheduledForLabel": "Recogida programada para:",
      "noPickupScheduledLabel": "Sin cita de recogida programada",
      "storeLabel": "Tienda",
      "openInGoogleMapsLabel": "Abrir en Google Maps",
      "appointmentDetailsLabel": "Detalles de la cita",
      "loadTypeLabel": "Tipo de carga",
      "warehouseInstructionsLabel": "Instrucciones del almacén",
      "amenitiesLabel": "Comodidades disponibles",
      "ppeRequirementsLabel": "EPP y otros requisitos",
      "dockDoorLabel": "Puerta de muelle",
      "dockInstructionsLabel": "Instrucciones del muelle",
      "carrierContactLabel": "Contacto del transportista"
    }
  }
}
